import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Priya & Aman Mehta",
    location: "London, UK",
    trip: "Serengeti Classic · 7 nights · Sept 2025",
    quote: "We've travelled a lot — but the way Apex paced our days felt different. Slow mornings, long game drives, sundowners by the truck. Our guide Emmanuel knew every animal by behaviour, not just by name.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
  },
  {
    name: "Daniel Schmidt",
    location: "Berlin, Germany",
    trip: "Grand Northern Circuit · Mar 2025",
    quote: "Three nights in the Serengeti was the right call. By the second morning our guide knew exactly which pride we'd find and where. I've never been that close to a hunt in my life.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200",
  },
  {
    name: "The Okafor Family",
    location: "Lagos, Nigeria",
    trip: "Family Safari + Zanzibar · Dec 2024",
    quote: "Three kids under 12, two grandparents, one nervous mum. They handled all of it. My father said it was the best holiday of his life. He's 71.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200",
  },
  {
    name: "Sarah Lindqvist",
    location: "Stockholm, Sweden",
    trip: "Northern Circuit · June 2025",
    quote: "Solo female traveller and I felt completely safe and looked after. The Ngorongoro morning was unforgettable — I had the crater rim almost to myself at sunrise.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-[#FAF6F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="overline">reviews</p>
          <h2 className="font-display text-5xl md:text-6xl italic font-light mt-4 leading-tight">
            What Our Travelers Say
          </h2>
          <p className="mt-5 text-[#23170E]/65">
            Every review below is real, posted by a recent guest. We've left them
            exactly as written — including the bits we couldn't have improved.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, idx) => (
            <article
              key={t.name}
              data-testid={`testimonial-${idx}`}
              className="bg-[#FFFFFF] rounded-3xl p-8 md:p-10 border border-[#E2D5C3] relative"
            >
              <Quote size={40} className="text-[#A6521B]/25 absolute top-6 right-6" />
              <div className="flex gap-1 mb-5" aria-label={`${t.rating} star rating`}>
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} size={14} fill="#A6521B" className="text-[#A6521B]" />
                ))}
              </div>
              <blockquote className="text-lg leading-relaxed text-[#23170E]/85">
                "{t.quote}"
              </blockquote>
              <div className="mt-8 pt-6 border-t border-[#E2D5C3] flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="font-marcellus text-lg text-[#23170E]">{t.name}</p>
                  <p className="text-xs text-[#23170E]/55 mt-0.5">{t.location} · {t.trip}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
